// Extended product data - Struktur Katalog Final PT. Gurita Mandala Persada
// Oleh : Indi Bagus Prasetyo (@in7.xyz)

// Default images for each category type
const valveImage = '/assets/categories/valve_category_cover_1773727188844.png';
const pipeImage = '/assets/categories/pipe_category_cover_1773727213243.png';
const fittingsImage = '/assets/categories/fittings_category_cover_1773727238681.png';
const steelImage = '/assets/categories/steel_category_cover_1773727263062.png';
const insulationImage = '/assets/categories/insulation_category_cover_1773727308739.png';
const industrialImage = '/assets/categories/industrial_category_cover_1773727330338.png';
const plateImage = '/assets/categories/plate_category_cover_1773727286035.png'; // Add plate directly

export const productCatalog = {
  valve: {
    id: 1,
    slug: 'valve',
    name: 'Valve',
    nameId: 'Valve',
    description: 'Industrial valves for flow control and system management',
    descriptionId: 'Valve industri untuk kontrol aliran dan manajemen sistem',
    image: valveImage,
    subCategories: [
      {
        id: 'gate-valve',
        name: 'Gate Valve',
        nameId: 'Gate Valve',
        description: 'Linear motion valve for on-off service',
        descriptionId: 'Valve gerak linear untuk layanan buka-tutup',
        image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800',
        brands: ['KITZ', 'TOYO', 'CRANE', 'VELAN', 'WALWORTH', 'NEWCON'],
        sizes: ['1/2"', '3/4"', '1"', '1-1/4"', '1-1/2"', '2"', '3"', '4"', '6"', '8"', '10"', '12"'],
        pressureRating: ['150 LB', '300 LB', '600 LB', 'PN10', 'PN16', 'PN25', 'PN40'],
        filters: {
          material: ['Cast Iron', 'Carbon Steel', 'Stainless Steel 304', 'Stainless Steel 316', 'Brass', 'Bronze'],
          connection: ['Flanged', 'Threaded (NPT/BSP)', 'Butt Weld', 'Socket Weld'],
          standard: ['JIS 10K/20K', 'ANSI 150/300/600', 'PN10/16/25/40', 'API 600']
        },
        applications: ['Water Supply', 'Oil & Gas', 'Steam System', 'Chemical Plant']
      },
      {
        id: 'globe-valve',
        name: 'Globe Valve',
        nameId: 'Globe Valve',
        description: 'Throttling valve for flow regulation',
        descriptionId: 'Valve throttling untuk regulasi aliran',
        image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800',
        brands: ['KITZ', 'TOYO', 'CRANE', 'VELAN', 'POWELL'],
        sizes: ['1/2"', '3/4"', '1"', '1-1/2"', '2"', '3"', '4"', '6"', '8"'],
        pressureRating: ['150 LB', '300 LB', '600 LB', 'PN16', 'PN25', 'PN40'],
        filters: {
          material: ['Cast Iron', 'Carbon Steel', 'Stainless Steel', 'Bronze'],
          connection: ['Flanged', 'Threaded'],
          standard: ['JIS 10K/20K', 'ANSI 150/300', 'PN16/25']
        },
        applications: ['Flow Control', 'Throttling Service', 'Steam System']
      },
      {
        id: 'ball-valve',
        name: 'Ball Valve',
        nameId: 'Ball Valve',
        description: 'Quarter-turn valve with spherical closure',
        descriptionId: 'Valve seperempat putaran dengan penutup bulat',
        image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800',
        brands: ['KITZ', 'APOLLO', 'WORCESTER', 'NELES', 'FLOWSERVE', 'CAMERON'],
        sizes: ['1/4"', '3/8"', '1/2"', '3/4"', '1"', '1-1/2"', '2"', '3"', '4"', '6"', '8"', '10"', '12"'],
        pressureRating: ['150 LB', '300 LB', '600 LB', '1500 LB', 'PN16', 'PN25', 'PN40', 'PN63'],
        filters: {
          material: ['Carbon Steel', 'Stainless Steel 304', 'Stainless Steel 316', 'Brass', 'PVC'],
          connection: ['Flanged', 'Threaded', 'Butt Weld', 'Socket Weld', 'Tri-Clamp'],
          standard: ['JIS 10K/20K', 'ANSI 150/300/600', 'PN16/25/40']
        },
        applications: ['General Purpose', 'Oil & Gas', 'Chemical', 'Food & Beverage']
      },
      {
        id: 'butterfly-valve',
        name: 'Butterfly Valve',
        nameId: 'Butterfly Valve',
        description: 'Rotary valve with disc closure',
        descriptionId: 'Valve rotary dengan disc penutup',
        image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800',
        brands: ['TOMOE', 'KEYSTONE', 'BRAY', 'DEZURIK', 'EBRO', 'KSB'],
        sizes: ['2"', '3"', '4"', '6"', '8"', '10"', '12"', '14"', '16"', '18"', '20"', '24"', '36"', '48"'],
        pressureRating: ['PN10', 'PN16', 'PN25', '150 LB', '300 LB'],
        filters: {
          material: ['Ductile Iron', 'Carbon Steel', 'Stainless Steel', 'Aluminum Bronze'],
          connection: ['Wafer Type', 'Lug Type', 'Flanged', 'Double Flanged'],
          standard: ['JIS 5K/10K', 'ANSI 150', 'PN10/16/25']
        },
        applications: ['HVAC', 'Water Treatment', 'Industrial Process', 'Fire Protection']
      },
      {
        id: 'check-valve',
        name: 'Check Valve',
        nameId: 'Check Valve',
        description: 'Non-return valve preventing backflow',
        descriptionId: 'Valve non-return mencegah aliran balik',
        image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800',
        brands: ['KITZ', 'CRANE', 'VELAN', 'MISSION', 'NEWCO'],
        sizes: ['1/2"', '3/4"', '1"', '1-1/2"', '2"', '3"', '4"', '6"', '8"', '10"', '12"'],
        pressureRating: ['150 LB', '300 LB', '600 LB', 'PN10', 'PN16', 'PN25'],
        subItems: ['Swing Check', 'Lift Check', 'Dual Plate / Wafer Check', 'Tilting Disc Check', 'Ball Check'],
        filters: {
          material: ['Cast Iron', 'Carbon Steel', 'Stainless Steel', 'Bronze'],
          connection: ['Flanged', 'Threaded', 'Wafer'],
          standard: ['JIS 10K/20K', 'ANSI 150/300', 'PN10/16/25']
        },
        applications: ['Pump Discharge', 'Pipeline Protection', 'Steam System']
      },
      {
        id: 'control-valve',
        name: 'Control Valve',
        nameId: 'Control Valve',
        description: 'Automated valve for precise flow control',
        descriptionId: 'Valve otomatis untuk kontrol aliran presisi',
        image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800',
        brands: ['FISHER', 'MASONEILAN', 'SAMSON', 'FLOWSERVE', 'METSO'],
        sizes: ['1"', '1-1/2"', '2"', '3"', '4"', '6"', '8"'],
        pressureRating: ['ANSI 150', 'ANSI 300', 'ANSI 600'],
        subItems: ['Globe Control Valve', 'Rotary Control Valve', 'Angle Control Valve'],
        filters: {
          material: ['Carbon Steel', 'Stainless Steel 316', 'Alloy Steel'],
          connection: ['Flanged'],
          actuator: ['Pneumatic', 'Electric', 'Hydraulic'],
          standard: ['ANSI/ISA', 'IEC']
        },
        applications: ['Process Control', 'Refinery', 'Power Plant', 'Petrochemical']
      },
      {
        id: 'safety-relief-valve',
        name: 'Safety / Relief Valve',
        nameId: 'Safety / Relief Valve',
        description: 'Pressure relief and safety valve',
        descriptionId: 'Valve pelepas tekanan dan keselamatan',
        image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800',
        brands: ['CONSOLIDATED', 'CROSBY', 'LESER', 'FARRIS', 'ANDERSON GREENWOOD'],
        sizes: ['1/2"', '3/4"', '1"', '1-1/2"', '2"', '3"', '4"', '6"'],
        pressureRating: ['Set Pressure: 0.5 - 400 bar'],
        subItems: ['Safety Valve', 'Relief Valve', 'Safety Relief Valve', 'Pilot Operated'],
        filters: {
          material: ['Carbon Steel', 'Stainless Steel', 'Brass', 'Bronze'],
          connection: ['Threaded NPT/BSP', 'Flanged'],
          standard: ['ASME Section VIII', 'API 520/526', 'TUV']
        },
        applications: ['Boiler', 'Pressure Vessel', 'Compressor', 'Process Equipment']
      },
      {
        id: 'needle-valve',
        name: 'Needle Valve',
        nameId: 'Needle Valve',
        description: 'Precise flow control valve',
        descriptionId: 'Valve kontrol aliran presisi',
        image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800',
        brands: ['PARKER', 'SWAGELOK', 'HAM-LET', 'HOKE', 'FITOK'],
        sizes: ['1/8"', '1/4"', '3/8"', '1/2"', '3/4"', '1"'],
        pressureRating: ['3000 PSI', '6000 PSI', '10000 PSI', '15000 PSI'],
        filters: {
          material: ['Stainless Steel 316', 'Carbon Steel', 'Brass', 'Monel', 'Alloy 20'],
          connection: ['NPT Thread', 'Compression Fitting', 'Tube Fitting'],
          standard: ['JIS', 'ANSI']
        },
        applications: ['Instrumentation', 'Sampling System', 'Gas Metering', 'Hydraulic System']
      }
    ]
  },
  
  pipe: {
    id: 2,
    slug: 'pipe',
    name: 'Pipe',
    nameId: 'Pipa',
    description: 'Industrial piping for various applications',
    descriptionId: 'Pipa industri untuk berbagai aplikasi',
    image: pipeImage,
    subCategories: [
      {
        id: 'carbon-steel-pipe',
        name: 'Pipa Hitam (Carbon Steel Pipe)',
        nameId: 'Pipa Hitam (Carbon Steel Pipe)',
        description: 'Black steel pipe for general use',
        descriptionId: 'Pipa baja hitam untuk penggunaan umum',
        image: pipeImage,
        brands: ['BAKRIE', 'SPINDO', 'NIPPON STEEL', 'SEAMLESS PIPE INDONESIA', 'CITRA TUBINDO'],
        sizes: ['1/2"', '3/4"', '1"', '1-1/4"', '1-1/2"', '2"', '2-1/2"', '3"', '4"', '5"', '6"', '8"', '10"', '12"', '14"', '16"', '18"', '20"', '24"'],
        filters: {
          schedule: ['SCH 10', 'SCH 20', 'SCH 40', 'SCH 80', 'SCH 160', 'XXS'],
          standard: ['ASTM A53 Gr.B', 'ASTM A106 Gr.B', 'JIS G3454 STPG', 'API 5L Gr.B']
        },
        applications: ['Plumbing', 'Structural', 'Oil & Gas', 'Steam Line']
      },
      {
        id: 'galvanized-pipe',
        name: 'Pipa Galvanis',
        nameId: 'Pipa Galvanis',
        description: 'Galvanized steel pipe',
        descriptionId: 'Pipa baja galvanis',
        image: pipeImage,
        brands: ['BAKRIE', 'SPINDO', 'KS', 'RUCIKA'],
        sizes: ['1/2"', '3/4"', '1"', '1-1/4"', '1-1/2"', '2"', '2-1/2"', '3"', '4"', '5"', '6"'],
        filters: {
          schedule: ['Medium (SCH 30)', 'Heavy (SCH 40)'],
          standard: ['ASTM A53', 'JIS G3442 SGP', 'BS 1387']
        },
        applications: ['Water Supply', 'Fire Protection', 'Scaffolding', 'Handrail']
      },
      {
        id: 'stainless-steel-pipe',
        name: 'Pipa Stainless Steel',
        nameId: 'Pipa Stainless Steel',
        description: 'Corrosion resistant stainless pipe',
        descriptionId: 'Pipa stainless tahan korosi',
        image: pipeImage,
        brands: ['SUMITOMO', 'NIPPON STEEL', 'SANDVIK', 'TUBACEX'],
        sizes: ['1/4"', '3/8"', '1/2"', '3/4"', '1"', '1-1/2"', '2"', '3"', '4"', '6"', '8"'],
        subItems: ['SS 304/304L', 'SS 316/316L', 'SS 321', 'SS 310'],
        filters: {
          schedule: ['SCH 5S', 'SCH 10S', 'SCH 40S', 'SCH 80S'],
          standard: ['ASTM A312', 'ASTM A269', 'JIS G3459']
        },
        applications: ['Food & Beverage', 'Pharmaceutical', 'Chemical', 'Marine']
      },
      {
        id: 'seamless-pipe',
        name: 'Pipa Seamless',
        nameId: 'Pipa Seamless',
        description: 'Seamless steel pipe',
        descriptionId: 'Pipa baja seamless',
        image: pipeImage,
        brands: ['TENARIS', 'TMK', 'VALLOUREC', 'SUMITOMO', 'JFE'],
        sizes: ['1/2"', '3/4"', '1"', '1-1/2"', '2"', '3"', '4"', '6"', '8"', '10"', '12"', '14"', '16"'],
        filters: {
          schedule: ['SCH 40', 'SCH 80', 'SCH 160', 'XXS'],
          standard: ['ASTM A106 Gr.B', 'API 5L PSL1/PSL2', 'ASTM A333']
        },
        applications: ['High Pressure', 'Oil & Gas', 'Boiler', 'Process Piping']
      },
      {
        id: 'welded-pipe',
        name: 'Pipa Welded',
        nameId: 'Pipa Welded',
        description: 'ERW and LSAW welded pipe',
        descriptionId: 'Pipa welded ERW dan LSAW',
        image: pipeImage,
        brands: ['SPINDO', 'CITRA TUBINDO', 'JFE', 'NIPPON STEEL'],
        sizes: ['2"', '4"', '6"', '8"', '10"', '12"', '14"', '16"', '18"', '20"', '24"', '30"', '36"', '42"', '48"'],
        subItems: ['ERW (Electric Resistance Welded)', 'LSAW (Longitudinal Submerged Arc Welded)', 'SSAW (Spiral Submerged Arc Welded)'],
        filters: {
          schedule: ['SCH 20', 'SCH 30', 'SCH 40', 'SCH 60'],
          standard: ['API 5L', 'ASTM A53', 'ASTM A672']
        },
        applications: ['Pipeline', 'Structural', 'Piling', 'Water Transmission']
      },
      {
        id: 'boiler-pipe',
        name: 'Pipa Boiler',
        nameId: 'Pipa Boiler',
        description: 'High temperature boiler pipe',
        descriptionId: 'Pipa boiler suhu tinggi',
        image: pipeImage,
        brands: ['SUMITOMO', 'VALLOUREC', 'TUBACEX', 'SALZGITTER'],
        sizes: ['1"', '1-1/2"', '2"', '2-1/2"', '3"', '4"', '5"', '6"'],
        filters: {
          schedule: ['SCH 40', 'SCH 80', 'SCH 120'],
          standard: ['ASTM A106 Gr.B/C', 'ASTM A335 P11/P22', 'JIS G3461 STB', 'DIN 17175']
        },
        applications: ['Boiler Tube', 'Superheater', 'Economizer', 'Heat Exchanger']
      },
      {
        id: 'spiral-pipe',
        name: 'Pipa Spiral',
        nameId: 'Pipa Spiral',
        description: 'Spiral welded pipe for large diameter',
        descriptionId: 'Pipa spiral untuk diameter besar',
        image: pipeImage,
        brands: ['CITRA TUBINDO', 'JFE', 'BAOSTEEL'],
        sizes: ['16"', '20"', '24"', '30"', '36"', '42"', '48"', '60"', '72"', '80"', '100"'],
        filters: {
          wallThickness: ['6mm', '8mm', '10mm', '12mm', '14mm', '16mm', '19mm', '25mm'],
          standard: ['API 5L', 'ASTM A252', 'AWWA C200']
        },
        applications: ['Water Pipeline', 'Piling', 'Oil & Gas Pipeline', 'Dredging']
      }
    ]
  },
  
  fittings: {
    id: 3,
    slug: 'fittings',
    name: 'Fittings',
    nameId: 'Fitting',
    description: 'Pipe fittings for connections and direction changes',
    descriptionId: 'Fitting pipa untuk koneksi dan perubahan arah',
    image: fittingsImage,
    subCategories: [
      {
        id: 'elbow',
        name: 'Elbow',
        nameId: 'Elbow',
        subItems: ['45° Elbow', '90° Elbow', '180° Return Bend', 'Long Radius', 'Short Radius'],
        description: 'Direction changing fittings',
        descriptionId: 'Fitting pengubah arah',
        image: fittingsImage,
        brands: ['ULMA', 'HACKNEY LADISH', 'TUBE TURNS', 'MSS'],
        sizes: ['1/2"', '3/4"', '1"', '1-1/2"', '2"', '3"', '4"', '6"', '8"', '10"', '12"'],
        filters: {
          material: ['Carbon Steel ASTM A234 WPB', 'Stainless Steel ASTM A403', 'Alloy Steel ASTM A234'],
          type: ['Butt Weld', 'Socket Weld', 'Threaded'],
          schedule: ['SCH 40', 'SCH 80', 'SCH 160']
        }
      },
      {
        id: 'tee',
        name: 'Tee',
        nameId: 'Tee',
        subItems: ['Equal Tee', 'Reducing Tee'],
        description: 'Branch connection fittings',
        descriptionId: 'Fitting koneksi cabang',
        image: fittingsImage,
        brands: ['ULMA', 'HACKNEY LADISH', 'TUBE TURNS'],
        sizes: ['1/2"', '3/4"', '1"', '1-1/2"', '2"', '3"', '4"', '6"', '8"', '10"', '12"'],
        filters: {
          material: ['Carbon Steel ASTM A234 WPB', 'Stainless Steel ASTM A403'],
          type: ['Butt Weld', 'Socket Weld', 'Threaded'],
          schedule: ['SCH 40', 'SCH 80']
        }
      },
      {
        id: 'reducer',
        name: 'Reducer',
        nameId: 'Reducer',
        subItems: ['Concentric Reducer', 'Eccentric Reducer'],
        description: 'Size transition fittings',
        descriptionId: 'Fitting transisi ukuran',
        image: fittingsImage,
        brands: ['ULMA', 'HACKNEY LADISH', 'BENKAN'],
        sizes: ['1/2" x 3/8"', '3/4" x 1/2"', '1" x 3/4"', '2" x 1"', '3" x 2"', '4" x 3"', '6" x 4"', '8" x 6"', '10" x 8"', '12" x 10"'],
        filters: {
          material: ['Carbon Steel', 'Stainless Steel'],
          type: ['Butt Weld', 'Socket Weld'],
          schedule: ['SCH 40', 'SCH 80']
        }
      },
      {
        id: 'cap',
        name: 'Cap',
        nameId: 'Cap',
        description: 'End closure fitting',
        descriptionId: 'Fitting penutup ujung',
        image: fittingsImage,
        brands: ['ULMA', 'HACKNEY LADISH'],
        sizes: ['1/2"', '3/4"', '1"', '1-1/2"', '2"', '3"', '4"', '6"', '8"', '10"', '12"'],
        filters: {
          material: ['Carbon Steel', 'Stainless Steel'],
          type: ['Butt Weld', 'Socket Weld', 'Threaded'],
          schedule: ['SCH 40', 'SCH 80']
        }
      },
      {
        id: 'coupling',
        name: 'Coupling',
        nameId: 'Coupling',
        description: 'Pipe connection coupling',
        descriptionId: 'Coupling koneksi pipa',
        image: fittingsImage,
        brands: ['WARD', 'ANVIL', 'CRANE'],
        sizes: ['1/4"', '3/8"', '1/2"', '3/4"', '1"', '1-1/4"', '1-1/2"', '2"', '3"', '4"'],
        subItems: ['Full Coupling', 'Half Coupling', 'Reducing Coupling'],
        filters: {
          material: ['Carbon Steel A105', 'Stainless Steel A182 F316', 'Forged Steel'],
          type: ['Socket Weld 3000#/6000#', 'Threaded 3000#/6000#']
        }
      },
      {
        id: 'union',
        name: 'Union',
        nameId: 'Union',
        description: 'Detachable pipe connection',
        descriptionId: 'Koneksi pipa dapat dilepas',
        image: fittingsImage,
        brands: ['WARD', 'BONNEY', 'CRANE'],
        sizes: ['1/4"', '3/8"', '1/2"', '3/4"', '1"', '1-1/4"', '1-1/2"', '2"'],
        filters: {
          material: ['Carbon Steel A105', 'Stainless Steel A182 F316', 'Brass'],
          type: ['Socket Weld 3000#/6000#', 'Threaded 3000#/6000#']
        }
      },
      {
        id: 'flange',
        name: 'Flange',
        nameId: 'Flange',
        subItems: ['Slip On Flange', 'Weld Neck Flange', 'Blind Flange', 'Socket Weld Flange', 'Threaded Flange', 'Lap Joint Flange', 'Orifice Flange'],
        description: 'Bolted connection flanges',
        descriptionId: 'Flange koneksi baut',
        image: fittingsImage,
        brands: ['ULMA', 'GALPERTI', 'TECHINT', 'BEBITZ'],
        sizes: ['1/2"', '3/4"', '1"', '1-1/2"', '2"', '3"', '4"', '6"', '8"', '10"', '12"', '14"', '16"', '18"', '20"', '24"'],
        filters: {
          material: ['Carbon Steel A105', 'Stainless Steel A182 F304/F316', 'Alloy Steel A182 F11/F22'],
          rating: ['150#', '300#', '600#', '900#', '1500#', '2500#'],
          face: ['Raised Face (RF)', 'Flat Face (FF)', 'Ring Type Joint (RTJ)']
        }
      },
      {
        id: 'nipple',
        name: 'Nipple',
        nameId: 'Nipple',
        description: 'Short pipe connector',
        descriptionId: 'Konektor pipa pendek',
        image: fittingsImage,
        brands: ['WARD', 'BECK', 'MERIT'],
        sizes: ['1/8"', '1/4"', '3/8"', '1/2"', '3/4"', '1"', '1-1/4"', '1-1/2"', '2"'],
        subItems: ['Close Nipple', 'Short Nipple', 'Long Nipple', 'Barrel Nipple', 'Swage Nipple'],
        filters: {
          material: ['Carbon Steel', 'Stainless Steel 304/316', 'Galvanized'],
          schedule: ['SCH 40', 'SCH 80', 'SCH 160']
        }
      }
    ]
  },
  
  steel: {
    id: 4,
    slug: 'steel',
    name: 'Steel Structure & Section',
    nameId: 'Struktur & Profil Baja',
    description: 'Structural steel and channel sections',
    descriptionId: 'Baja struktural dan profil kanal',
    image: steelImage,
    subCategories: [
      {
        id: 'structural-beam',
        name: 'Structural Beam',
        nameId: 'Balok Struktural',
        subItems: ['H-Beam (Wide Flange)', 'I-Beam (IWF)', 'WF (Wide Flange)', 'Universal Beam'],
        description: 'Heavy structural beams',
        descriptionId: 'Balok struktural berat',
        image: steelImage,
        brands: ['KRAKATAU STEEL', 'GUNUNG GARUDA', 'ISPATINDO', 'JFE', 'NIPPON STEEL'],
        sizes: ['100x100', '125x125', '150x150', '175x175', '200x200', '250x250', '300x300', '350x350', '400x400', '450x200', '500x200', '600x200'],
        filters: {
          standard: ['JIS G3101 SS400', 'ASTM A36', 'ASTM A992', 'EN 10025 S275JR'],
          length: ['6m', '12m', 'Custom Cut']
        }
      },
      {
        id: 'channel-profile',
        name: 'Channel & Profile',
        nameId: 'Kanal & Profil',
        subItems: ['UNP (U Channel)', 'CNP (C Channel / Lip Channel)', 'Angle Bar (Siku L)', 'T-Bar', 'Flat Bar'],
        description: 'Channel and profile sections',
        descriptionId: 'Profil kanal dan section',
        image: steelImage,
        brands: ['KRAKATAU STEEL', 'GUNUNG GARUDA', 'MASTER STEEL'],
        sizes: ['UNP: 50-400mm', 'CNP: 75-300mm', 'Angle: 20x20 - 200x200mm'],
        filters: {
          standard: ['JIS G3101 SS400', 'ASTM A36', 'SNI'],
          length: ['6m', '12m']
        }
      },
      {
        id: 'hollow-section',
        name: 'Hollow Section',
        nameId: 'Hollow Section',
        subItems: ['Square Hollow Section (SHS)', 'Rectangular Hollow Section (RHS)', 'Circular Hollow Section (CHS)'],
        description: 'Hollow structural sections',
        descriptionId: 'Section struktural hollow',
        image: steelImage,
        brands: ['BAKRIE', 'SPINDO', 'GUNUNG GARUDA', 'MASTER STEEL'],
        sizes: ['20x20 - 400x400mm (Square)', '25x50 - 200x400mm (Rectangular)', 'OD 21.3 - 323.9mm (Round)'],
        filters: {
          thickness: ['1.2mm', '1.6mm', '2.0mm', '2.3mm', '3.0mm', '4.0mm', '5.0mm', '6.0mm'],
          standard: ['JIS G3466', 'ASTM A500', 'EN 10210'],
          length: ['6m']
        }
      }
    ]
  },
  
  plate: {
    id: 5,
    slug: 'plate',
    name: 'Steel Plate',
    nameId: 'Plat Besi',
    description: 'Steel plates for various industrial applications',
    descriptionId: 'Plat baja untuk berbagai aplikasi industri',
    image: plateImage,
    subCategories: [
      {
        id: 'carbon-steel-plate',
        name: 'Carbon Steel Plate',
        nameId: 'Plat Baja Karbon',
        subItems: [
          'Plat Hitam (Hot Rolled Plate)',
          'Plat Pickled & Oiled (PO)',
          'Plat Cold Rolled (CR/CRC)'
        ],
        description: 'Carbon steel plates',
        descriptionId: 'Plat baja karbon',
        image: plateImage,
        brands: ['KRAKATAU STEEL', 'POSCO', 'JFE', 'BAOSTEEL', 'ESSAR'],
        filters: {
          thickness: ['1.2mm', '1.5mm', '2.0mm', '3.0mm', '4.0mm', '4.5mm', '5.0mm', '6.0mm', '8.0mm', '10mm', '12mm', '16mm', '20mm', '25mm', '30mm', '40mm', '50mm', '60mm', '80mm', '100mm'],
          size: ['4x8 feet (1219x2438mm)', '5x10 feet (1524x3048mm)', '5x20 feet (1524x6096mm)', '6x20 feet (1829x6096mm)', 'Custom Cut'],
          standard: ['JIS G3101 SS400', 'ASTM A36', 'ASTM A283 Gr.C', 'DIN ST37-2']
        },
        applications: ['General Fabrication', 'Machinery', 'Construction', 'Shipbuilding']
      },
      {
        id: 'special-plate',
        name: 'Special Plate',
        nameId: 'Plat Khusus',
        subItems: [
          'Plat Bordes (Checkered Plate / Diamond Plate)',
          'Plat Kapal (Shipbuilding Plate)',
          'Plat Boiler (Pressure Vessel Plate)',
          'Wear Resistant Plate (Hardox)'
        ],
        description: 'Special purpose steel plates',
        descriptionId: 'Plat baja khusus',
        image: plateImage,
        brands: ['KRAKATAU STEEL', 'JFE', 'SSAB (HARDOX)', 'NIPPON STEEL'],
        filters: {
          thickness: ['2.3mm', '3.0mm', '4.0mm', '4.5mm', '5.0mm', '6.0mm', '8.0mm', '10mm', '12mm', '16mm', '20mm', '25mm'],
          standard: ['JIS G3101', 'ASTM A516 Gr.70', 'ABS/LR/BV/DNV (Marine)', 'EN 10028']
        },
        applications: ['Flooring', 'Platform', 'Shipbuilding', 'Pressure Vessel', 'Mining Equipment']
      },
      {
        id: 'stainless-steel-plate',
        name: 'Stainless Steel Plate',
        nameId: 'Plat Stainless Steel',
        subItems: ['SS 201', 'SS 304/304L', 'SS 316/316L', 'SS 310S', 'SS 430'],
        description: 'Corrosion resistant stainless plates',
        descriptionId: 'Plat stainless tahan korosi',
        image: plateImage,
        brands: ['POSCO', 'TISCO', 'BAOSTEEL', 'OUTOKUMPU', 'ACERINOX'],
        filters: {
          thickness: ['0.4mm', '0.5mm', '0.6mm', '0.8mm', '1.0mm', '1.2mm', '1.5mm', '2.0mm', '3.0mm', '4.0mm', '5.0mm', '6.0mm', '8.0mm', '10mm', '12mm', '15mm', '20mm'],
          finish: ['2B (Mill Finish)', 'BA (Bright Annealed)', 'No.4 (Brushed/Hairline)', 'Mirror (No.8)', 'Embossed'],
          standard: ['ASTM A240', 'JIS G4305', 'EN 10088']
        },
        applications: ['Food Processing', 'Chemical Plant', 'Architecture', 'Medical Equipment']
      }
    ]
  },
  
  insulation: {
    id: 6,
    slug: 'insulation',
    name: 'Insulation',
    nameId: 'Insulasi',
    description: 'Thermal and acoustic insulation materials',
    descriptionId: 'Material insulasi termal dan akustik',
    image: insulationImage,
    subCategories: [
      {
        id: 'glasswool',
        name: 'Glasswool',
        nameId: 'Glasswool',
        description: 'Fiberglass insulation',
        descriptionId: 'Insulasi fiberglass',
        image: insulationImage,
        brands: ['KNAUF', 'ISOVER', 'OWENS CORNING', 'ROCKWOOL'],
        subItems: ['Glasswool Blanket', 'Glasswool Board', 'Glasswool Pipe Section'],
        filters: {
          density: ['16 kg/m³', '24 kg/m³', '32 kg/m³', '48 kg/m³', '64 kg/m³', '96 kg/m³'],
          thickness: ['25mm', '50mm', '75mm', '100mm'],
          maxTemp: ['Up to 450°C']
        },
        applications: ['HVAC Duct', 'Building Insulation', 'Industrial Pipe']
      },
      {
        id: 'rockwool',
        name: 'Rockwool',
        nameId: 'Rockwool',
        description: 'Stone wool insulation',
        descriptionId: 'Insulasi stone wool',
        image: insulationImage,
        brands: ['ROCKWOOL', 'PAROC', 'KNAUF'],
        subItems: ['Rockwool Blanket', 'Rockwool Board', 'Rockwool Pipe Section', 'Rockwool Loose Fill'],
        filters: {
          density: ['40 kg/m³', '60 kg/m³', '80 kg/m³', '100 kg/m³', '120 kg/m³', '150 kg/m³'],
          thickness: ['25mm', '50mm', '75mm', '100mm', '150mm'],
          maxTemp: ['Up to 750°C']
        },
        applications: ['High Temperature', 'Fire Protection', 'Acoustic', 'Industrial']
      },
      {
        id: 'ceramic-fiber',
        name: 'Ceramic Fiber',
        nameId: 'Ceramic Fiber',
        description: 'High temperature ceramic insulation',
        descriptionId: 'Insulasi keramik suhu tinggi',
        image: insulationImage,
        brands: ['UNIFRAX', 'MORGAN THERMAL', 'LUYANG', 'NUTEC'],
        subItems: ['Ceramic Fiber Blanket', 'Ceramic Fiber Board', 'Ceramic Fiber Paper', 'Ceramic Fiber Module', 'Ceramic Fiber Rope'],
        filters: {
          grade: ['1260°C (Standard)', '1400°C (HP)', '1600°C (HZ)'],
          density: ['64 kg/m³', '96 kg/m³', '128 kg/m³'],
          thickness: ['12.5mm', '25mm', '50mm']
        },
        applications: ['Furnace Lining', 'Kiln', 'Refractory', 'High Temperature Gasket']
      },
      {
        id: 'rubber-insulation',
        name: 'Rubber Insulation',
        nameId: 'Rubber Insulation',
        description: 'Flexible rubber insulation',
        descriptionId: 'Insulasi karet fleksibel',
        image: insulationImage,
        brands: ['ARMAFLEX', 'K-FLEX', 'AEROFLEX', 'SUPERLON'],
        subItems: ['Rubber Tube/Pipe', 'Rubber Sheet/Roll', 'Rubber Tape'],
        filters: {
          thickness: ['6mm', '9mm', '13mm', '19mm', '25mm', '32mm'],
          pipeSize: ['3/8"', '1/2"', '5/8"', '3/4"', '7/8"', '1-1/8"', '1-3/8"', '2-1/8"', '2-5/8"', '3-1/8"', '4-1/8"'],
          tempRange: ['-40°C to +105°C']
        },
        applications: ['HVAC', 'Refrigeration', 'Chilled Water', 'Condensation Prevention']
      },
      {
        id: 'aluminium-jacketing',
        name: 'Aluminium Jacketing',
        nameId: 'Aluminium Jacketing',
        description: 'Protective aluminium cladding',
        descriptionId: 'Pelindung aluminium',
        image: insulationImage,
        brands: ['NOVELIS', 'ELVAL', 'HINDALCO'],
        subItems: ['Flat Sheet', 'Corrugated Sheet', 'Embossed/Stucco Sheet'],
        filters: {
          thickness: ['0.4mm', '0.5mm', '0.6mm', '0.7mm', '0.8mm', '1.0mm'],
          alloy: ['AA1100', 'AA3003', 'AA3105'],
          finish: ['Plain/Mill', 'Stucco Embossed', 'Corrugated']
        },
        applications: ['Pipe Jacketing', 'Equipment Cladding', 'Weather Protection']
      },
      {
        id: 'gi-jacketing',
        name: 'GI Jacketing',
        nameId: 'GI Jacketing',
        description: 'Galvanized iron jacketing',
        descriptionId: 'Jacketing besi galvanis',
        image: insulationImage,
        brands: ['BLUESCOPE', 'NIPPON STEEL'],
        subItems: ['Flat Sheet', 'Corrugated Sheet'],
        filters: {
          thickness: ['0.4mm', '0.5mm', '0.6mm', '0.7mm', '0.8mm'],
          coating: ['Z120', 'Z180', 'Z275'],
          finish: ['Plain', 'Corrugated']
        },
        applications: ['Outdoor Jacketing', 'Industrial Cladding']
      }
    ]
  },
  
  industrial: {
    id: 7,
    slug: 'industrial',
    name: 'Industrial Support & Hardware',
    nameId: 'Pendukung & Hardware Industri',
    description: 'Industrial components, fasteners and safety equipment',
    descriptionId: 'Komponen industri, fastener dan alat keselamatan',
    image: industrialImage,
    subCategories: [
      {
        id: 'mechanical-components',
        name: 'Mechanical Components',
        nameId: 'Komponen Mekanik',
        subItems: ['Bearing (Ball/Roller/Thrust)', 'Chain & Sprocket', 'V-Belt & Pulley', 'Seal & Gasket', 'Coupling'],
        description: 'Industrial mechanical parts',
        descriptionId: 'Komponen mekanik industri',
        image: industrialImage,
        brands: ['SKF', 'NSK', 'FAG', 'NTN', 'TIMKEN', 'GATES', 'OPTIBELT', 'TSUBAKI', 'REXNORD'],
        filters: {
          category: ['Bearing', 'Power Transmission', 'Sealing']
        },
        applications: ['Rotating Equipment', 'Conveyor', 'Pump', 'Motor']
      },
      {
        id: 'fastener',
        name: 'Fastener',
        nameId: 'Fastener',
        subItems: ['Hex Bolt & Nut', 'Stud Bolt & Nut', 'Anchor Bolt', 'U-Bolt', 'Eye Bolt', 'Washer', 'Machine Screw'],
        description: 'Industrial fastening solutions',
        descriptionId: 'Solusi fastening industri',
        image: industrialImage,
        brands: ['BOSSARD', 'HILTI', 'RAWL', 'LOCAL MILL'],
        filters: {
          material: ['Carbon Steel Gr.8.8', 'Carbon Steel Gr.10.9', 'Stainless Steel A2-70', 'Stainless Steel A4-80', 'Galvanized', 'HDG'],
          size: ['M6', 'M8', 'M10', 'M12', 'M16', 'M20', 'M24', 'M27', 'M30', 'M36'],
          standard: ['DIN', 'ISO', 'ASTM A193 B7', 'ASTM A194 2H']
        },
        applications: ['Steel Structure', 'Piping', 'Equipment Mounting', 'Flanged Connection']
      },
      {
        id: 'safety-equipment',
        name: 'Safety Equipment (PPE)',
        nameId: 'Alat Keselamatan (APD)',
        subItems: ['Safety Helmet', 'Safety Glasses/Goggles', 'Safety Gloves', 'Safety Shoes/Boots', 'Coverall/Wearpack', 'Safety Harness', 'Ear Protection', 'Respiratory Protection'],
        description: 'Personal protective equipment',
        descriptionId: 'Alat pelindung diri',
        image: industrialImage,
        brands: ['3M', 'HONEYWELL', 'MSA', 'UVEX', 'DELTAPLUS', 'KRISBOW', 'KINGS'],
        filters: {
          category: ['Head Protection', 'Eye Protection', 'Hand Protection', 'Foot Protection', 'Body Protection', 'Fall Protection', 'Hearing Protection', 'Respiratory Protection'],
          certification: ['SNI', 'ANSI', 'EN', 'CE']
        },
        applications: ['Construction', 'Manufacturing', 'Oil & Gas', 'Mining', 'Chemical Plant']
      },
      {
        id: 'tools',
        name: 'Tools',
        nameId: 'Tools',
        subItems: ['Hand Tools (Wrench, Plier, Screwdriver, Hammer)', 'Power Tools (Drill, Grinder, Impact Wrench)', 'Measuring Tools (Caliper, Micrometer, Tape)', 'Cutting Tools (Pipe Cutter, Hacksaw)'],
        description: 'Industrial tools',
        descriptionId: 'Perkakas industri',
        image: industrialImage,
        brands: ['STANLEY', 'SNAP-ON', 'BAHCO', 'RIDGID', 'DEWALT', 'BOSCH', 'MAKITA', 'MITUTOYO'],
        filters: {
          category: ['Hand Tools', 'Power Tools', 'Measuring & Testing', 'Cutting Tools']
        },
        applications: ['Maintenance', 'Installation', 'Repair', 'Fabrication']
      }
    ]
  }
};

// Simple array for navigation
export const productCategories = [
  { id: 1, slug: 'valve', ...productCatalog.valve },
  { id: 2, slug: 'pipe', ...productCatalog.pipe },
  { id: 3, slug: 'fittings', ...productCatalog.fittings },
  { id: 4, slug: 'steel', ...productCatalog.steel },
  { id: 5, slug: 'plate', ...productCatalog.plate },
  { id: 6, slug: 'insulation', ...productCatalog.insulation },
  { id: 7, slug: 'industrial', ...productCatalog.industrial }
];
